<template>
	<div class="my-3 my-md-5">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<form id="dash-form" class="card" @submit.prevent="submitDetailsForm">
						<div class="card-header justify-content-between">
							<h3 class="card-title">Home Banner</h3>
						</div>
						<div class="card-body">
							<div class="row">
								<div class="col-md-12">
									<div class="form-group alert alert-danger" role="alert">
										Woops! Something Went Wrong, Please Try Again.
									</div>  
								</div>
								<div class="col-md-12">
									<TextEditor :data="formData.banner" name="banner" label="Banner Text" :required="true" v-bind:value.sync="formData.banner"/>
								</div>
							</div>
						</div>
						<div class="card-footer text-right">
							<div class="d-flex justify-content-end">
								<button type="reset" class="btn btn-secondary">Reset</button>
								<button type="submit" id="submit" class="btn btn-primary ml-2 text-uppercase">Sumbit</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import TextEditor from '@/components/form/TextEditor.vue'

export default {
	name: 'Banner',
	components: {
		TextEditor
	},
	data() {
		return {
			formData: {
				banner: ''
			},
			dataId: ''
		}
	},
	computed: {
		dataArray: function() {
			return this.$store.getters.getBanner;
		}
	},
	mounted() {
		// Hide loader
		this.$store.dispatch('setLoading', false);
		/* global $ */
		let self = this;
	    // Dummy Data
		/*this.formData.banner = `<p><strong>Welcome to the Radix Developer Dashboard!</strong> Simple things should be simple, complex things should be POSSIBLE.<br>Some of our favourite sites include: <a href="https://stackoverflow.com/" target="_blank">Stackoverflow</a>, <a href="https://github.io" target="_blank">Github</a>, <a href="https://codepen.io" target="_blank">Codepen</a>, <a href="https://tympanus.net/codrops/" target="_blank">Codrops</a></p>`;*/
		// Assign Banner Data
		this.assignBannerData(this.dataArray);
	},
	methods: {
		submitDetailsForm: function() {
			let self = this;
			// Check Vee Validate
			self.$validator.validateAll().then((result) => {
				if (result) {
					// Edit Banner Data
					self.sendData('banner-details', self.formData, self.dataId);
					return;
				}
			});
		},
		assignBannerData: function(array) {
			if(array.length != 0) {
				this.dataId = this.dataArray[0]._id;
				this.formData.banner = this.dataArray[0].banner;
			}
			else {
				this.dataId = "";
				this.formData.banner = "";
			}
		}
	},
	watch: {
		dataArray: {
			handler: function(val) {
				this.assignBannerData(val);
			},
			deep: true
		},
	}
}
</script>
